import React, { FC } from 'react';
import { INCIDENT_TYPE, INVESTIGATION_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import DisplayNameColumn from '../../../../components/Tables/Columns/DisplayNameColumn';

interface Props {
    label: string;
    id: string;
    kind: string;
}

const IncidentColumn: FC<Props> = ({ label, id, kind }) => {
    const onInvestigateClicked = () => {
        const kindValue = Object.values(INCIDENT_TYPE).find((type) => type.apiName === kind)?.value ?? 'Not Found';
        const url = `${INVESTIGATION_ENTITY_TYPES.INCIDENT.urlPrefix}${kindValue}/${id}?ref=risk`;
        window.open(url);
    };

    return (
        <DisplayNameColumn
            topText={label}
            bottomText={id.slice(0, 11)}
            onTopTextClick={onInvestigateClicked}
            onActionClick={onInvestigateClicked}
            actionTooltip="Investigate"
        />
    );
};

export default IncidentColumn;
